// Considered: TooltipAtom — atoms cannot safely compose other atoms; HelpTipAtom imports
// primereact/tooltip directly (atoms are the only layer permitted to do so) to avoid the
// atom-imports-atom chain. Pattern matches ScopeCoinAtom → GlyphAtom precedent where the
// import is justified. See spec Reuse Audit (specs/sphere-selector-and-subscriptions.md).
import React, { useId } from 'react';
import { Tooltip } from 'primereact/tooltip';
import './HelpTipAtom.scss';

export interface HelpTipAtomProps {
  text: string;
  className?: string;
}

const HelpTipAtom: React.FC<HelpTipAtomProps> = ({ text, className = '' }) => {
  const uid = useId().replaceAll(':', '');
  const triggerId = `helptip-trigger-${uid}`;

  return (
    <span className={['helptip-atom', className].filter(Boolean).join(' ')}>
      <i
        id={triggerId}
        className="pi pi-info-circle helptip-atom__icon"
        data-pr-tooltip={text}
        data-pr-position="top"
        aria-label={text}
        role="img"
      />
      <Tooltip target={`#${triggerId}`} />
    </span>
  );
};

HelpTipAtom.displayName = 'HelpTipAtom';

export default HelpTipAtom;
